import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1a381165"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-center fl-jc-sb fl-1" }
const _hoisted_2 = { class: "flex flex-center" }
const _hoisted_3 = ["title"]

import { ref, watch } from "vue";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";
import DownloadDashboardDialog from "@/shared/dialogs/DownloadDashboardDialog.vue";
import Button from "primevue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopPreSalePanel',
  props: {
    nameDashbords: {},
    isDashboardSelected: { type: Boolean }
  },
  emits: [
  "setCommonFilter",
  "toggleArchive",
  "toggleFilter",
  "createAction",
  "expandDashboard",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const searchField = ref(null);
const debounceTimeout = ref(0);

const sendItemRequest = () => {
  emit("setCommonFilter", searchField.value);
};

const visible = ref(false);

watch(
  () => searchField.value,
  () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(sendItemRequest, 400);
  },
  { immediate: true }
);

const items = ref([
  { label: "Аналитика", archive: "both" },
  { label: props.nameDashbords, archive: "both" },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPanel, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BreadCrumbs, { items: items.value }, null, 8, ["items"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "hint",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
          }, " Как скачать данные дашборда в формате XLSX? "),
          _createElementVNode("div", {
            title: 
            !props.isDashboardSelected
              ? 'Сначала выберите дашборд'
              : 'Развернуть дашборд на весь экран'
          
          }, [
            _createVNode(_unref(Button), {
              disabled: !props.isDashboardSelected,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('expandDashboard'))),
              icon: "pi pi-window-maximize",
              label: "Во весь экран",
              class: "expand-button",
              pt: {
              root: {
                style: 'min-width: 150px; white-space: nowrap; height: 32px',
              },
            }
            }, null, 8, ["disabled"])
          ], 8, _hoisted_3)
        ])
      ]),
      _createVNode(DownloadDashboardDialog, {
        visible: visible.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
      }, null, 8, ["visible"])
    ]),
    _: 1
  }))
}
}

})